<app-closeable-dialog-title
  [allowMaximize]="false"
  [title]="(data.criteria && data.criteria.id) ? 'Update criteria' :'Add criteria'">
</app-closeable-dialog-title>

<div mat-dialog-content class="content">
  <form [formGroup]="form">

    <mat-radio-group class="include-select" formControlName="includeCriteria" aria-label="Select an if its included">
      <mat-radio-button [value]="true">Inclusion criteria</mat-radio-button>
      <mat-radio-button [value]="false">Exclusion criteria</mat-radio-button>
    </mat-radio-group>

    <mat-form-field appearance="fill" class="full-width">
      <mat-label>Name</mat-label>
      <input matInput formControlName="name"/>
    </mat-form-field>

    <mat-form-field appearance="fill" class="full-width">
      <mat-label>Criteria</mat-label>
      <textarea matInput formControlName="criteria"
                placeholder="the study provides a comprehensive description of an AI"></textarea>
    </mat-form-field>
  </form>

  <p>{{ getPreviewStatement }}</p>
  <button mat-raised-button (click)="evalScreeningCriteria()">Evaluate this criteria</button>
  @if (evaluation && !loadingEvaluation) {

    <mat-card class="criteria-card">
      <mat-card-header>
        <mat-icon mat-card-avatar [color]="evaluation.isWellChosen ? 'primary' : 'warn'">
          {{ evaluation!.isWellChosen ? 'check_circle' : 'error' }}
        </mat-icon>
        <mat-card-title>Criterion Evaluation Result</mat-card-title>
        <mat-card-subtitle>Criterion is {{ evaluation!.isWellChosen ? 'Effectively Chosen' : 'Ineffective' }}
        </mat-card-subtitle>
      </mat-card-header>
      <mat-card-content>


        <h4>Reason</h4>
        <p>{{ evaluation!.reason }}</p>
        <mat-divider></mat-divider>

        @if (!evaluation!.isWellChosen) {
          <h4>Suggestion for Improvement</h4>
          <p>{{ evaluation!.suggestion }}</p>
        }
      </mat-card-content>
    </mat-card>
  }
  @if (loadingEvaluation) {
    <app-loading-card
      class="no-settings-card"
      title="We are analyzing your criteria">
      <p>Analyzing your criteria and creating meaningful evaulation for you ...</p>
    </app-loading-card>
  }
</div>

<div mat-dialog-actions class="actions">
  @if (data.criteria && data.criteria.id) {
    <button mat-button class="delete-btn" (click)="delete()">
      <mat-icon>save</mat-icon>
      Delete
    </button>
  }
  <span class="spacer"></span>
  <button mat-button class="save-btn" [disabled]="form.invalid" (click)="save()">
    <mat-icon>save</mat-icon>
    Save
  </button>
</div>
